import { INFORMATION_SOURCE } from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const Dispositionskredit = z.object({
    abloesen: z.boolean().default(false),
    beanspruchterBetrag: schemaBigDecimal.nullish().default(null),
    bic: z
        .string()
        .transform((val) => val?.toUpperCase())
        .nullish()
        .default(null),
    createdAt: z.coerce.date().nullish(),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    glaeubiger: z.string().nullish().default(null),
    iban: z.string().nullish().default(null),
    // TODO weitere tests
    id: schemaId,
    // NOTE: the europace schema does not contains the kreditinstitut key
    kreditinstitut: z.string().nullish().default(null),
    source: z.nativeEnum(INFORMATION_SOURCE).optional().default(INFORMATION_SOURCE.FORMULAR),
    verfuegungsrahmen: schemaBigDecimal.nullish().default(null),
    zinssatz: schemaBigDecimal.nullish().default(null),
});

// INFO yup schema
//                         yup.object().shape(
//                             {
//                                 abloesen: yup.boolean().optional().nullable().default(false),
//                                 beanspruchterBetrag: yup.number().optional().nullable().default(null),
//                                 bic: yup
//                                     .string()
//                                     .uppercase()
//                                     .optional()
//                                     .nullable()
//                                     .test(...yupTests.bic),
//                                 gehoertZuAntragsteller: yup
//                                     .string()
//                                     .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE'])
//                                     .required(),
//                                 glaeubiger: yup.string().optional().nullable().default(null),
//                                 iban: yup
//                                     .string()
//                                     .optional()
//                                     .nullable()
//                                     .test(...yupTests.iban),
//                                 id: yup.string(),
//                                 kreditinstitut: yup.string().optional().nullable().default(null),
//                                 source: yup.string().oneOf(['FORMULAR', 'SCHUFA']).optional().default('FORMULAR'),
//                                 verfuegungsrahmen: yup.number().optional().nullable().default(null),
//                                 zinssatz: yup.number().optional().nullable().default(null),
//                             },
//                             bankAccountFieldValidationOrder,
//                         ),
